import {
  deleteGallery,
  getGalleryImage,
  searchGallery,
  createGallery,
  updateGalleryImage,
  // getGallery,
} from '../services/gallery';
import defaultGallery from '../assets/img/gallery_default.png';
import swal from 'sweetalert';
import { updateContacts } from '../services/contacts';
import { CHECK_MARK, optionPrefix } from './constant/contact';
import pLimit from 'p-limit';
import { BASE_STORAGE_URL } from './constant';
const limit = pLimit(30);
export const fetchGallery = async (data) => {
  const response = await searchGallery(data);
  return response;
};

export const fetchGalleryDetails = async (setGalleryData, setGalleryImages) => {
  const data = { q: '*' };
  const res = await fetchGallery(data);
  if (res.status === 200) {
    const sortData =
      res.data.objects.sort((a, b) => {
        // console.log(a);
        return a.name.localeCompare(b.name);
      }) || [];
    // setContactsData(res.data.objects);
    setGalleryData(sortData);
    // console.log('length', sortData.length);
    const galleryImages = sortData.reduce(
      (result, item) => ({ ...result, [item._id]: getPublicUrl(item.avatar) }),
      {}
    );
    // console.log('galleryImages', galleryImages);
    setGalleryImages(galleryImages);
    // const process = sortData.map((item) =>
    //   limit(async () => {
    //     // console.count('count');
    //     if (item.avatar) {
    //       const resImg = await getGalleryImage(item._id);
    //       let base64ImageString =
    //         resImg?.data &&
    //         Buffer.from(resImg.data, 'binary').toString('base64');
    //       if (resImg?.status === 200) {
    //         setGalleryImages((prevState) => ({
    //           ...prevState,
    //           [item._id]: 'data:image/jpeg;base64,' + base64ImageString,
    //         }));
    //       } else {
    //         setGalleryImages((prevState) => ({
    //           ...prevState,
    //           [item._id]: defaultGallery,
    //         }));
    //       }
    //     } else {
    //       setGalleryImages((prevState) => ({
    //         ...prevState,
    //         [item._id]: defaultGallery,
    //       }));
    //     }
    //   })
    // );
    // await Promise.all(process);
    // console.log('done');
  }
};

export const editGallery = (
  setModalAction,
  setEditInitialValues,
  setPreviewScreen,
  initialPreviewScreen,
  setShowModal,
  data,
  imageContactData,
  setFilterContact,
  setRemoveGalleryIdContact
) => {
  setModalAction && setModalAction('edit');
  setPreviewScreen &&
    setPreviewScreen((prevState) => ({
      ...initialPreviewScreen,
      name: data.name,
    }));
  setShowModal && setShowModal(true);
  const test = [];
  imageContactData.forEach((e) => {
    if (e.galleryId === data._id) {
      test.push(e.contactId);
    }
  });

  setEditInitialValues &&
    setEditInitialValues((prevState) => ({
      ...prevState,
      id: data._id,
      name: data.name,
      contactId: test,
    }));
  setFilterContact && setFilterContact(test);
  setRemoveGalleryIdContact && setRemoveGalleryIdContact(test);
};

export const removeGallery = async (
  galleryId,
  setGalleryData,
  galleryData,
  imageContactData
) => {
  const test = [];
  const wrapper = document.createElement('div');
  wrapper.innerHTML =
    '<p class="swal-text-data">Are you sure you want to delete this gallery?</p> ' +
    '<p class="swal-text-data">Deleting a gallery is a permanent action. Once removed it cannot be restored or modified</p>';
  swal({
    title: 'Delete Confirmation',
    content: wrapper,
    buttons: {
      confirm: {
        width: 30,
        text: 'Delete',
        value: 'delete',
        visible: true,
        className: 'swal-delete-button',
        closeModal: true,
      },
      cancel: {
        width: 15,
        text: 'Cancel',
        value: 'cancel',
        visible: true,
        className: 'swal-cancel-button',
        closeModal: true,
      },
    },
  }).then((willDelete) => {
    if (willDelete === 'delete') {
      imageContactData.forEach((e) => {
        if (e.galleryId === galleryId) {
          test.push(e.contactId);
        }
      });
      deleteGallery(galleryId).then((res) => {
        if (res.status === 204) {
          const tempContactsData = [...galleryData];
          const updatedContactsData = tempContactsData.filter(
            (item) => item._id !== galleryId
          );
          setGalleryData(updatedContactsData);
        }
      });
      test &&
        test.length > 0 &&
        test.forEach(async (id) => {
          await updateContacts(id, { galleryId: null });
        });
    }
  });
};

function checkHasCheckMark(name) {
  if (!name) return false;

  return name?.includes(CHECK_MARK);
}

export function getOnlyFirstName(name) {
  if (!name) return '';

  let _name = name;

  const isCheckMark = checkHasCheckMark(_name);

  if (isCheckMark) {
    _name = name.replaceAll(CHECK_MARK, '');
  }

  const findPrefixOption = optionPrefix.findLast((item) =>
    _name?.startsWith(item.value)
  );

  return findPrefixOption
    ? _name.replaceAll(findPrefixOption.value, '')
    : _name;
}

export async function uploadImage(files, params) {
  if (files?.length) {
    const file = files[0];
    // console.log('file', file);
    if (!file.preview) {
      return;
    }
    const formData = new FormData();
    formData.append(
      'fieldModifiers',
      JSON.stringify({
        avatar: file.name,
        ...params,
        // objectType: objectType
      })
    );

    let demo = await fetch(file.preview).then((r) => r.blob());

    formData.append('file', demo);

    const response = await createGallery({
      name: file.name || params.avatar || '-',
      type: params?.type,
    });

    const res = await updateGalleryImage(response.data._id, formData);

    // console.log('res', res);
    if (res.status === 200) {
      // const publicURL = new URL(res.data.publicURL);
      // publicURL.searchParams.set('_id', res.data.logoId);
      // onChange?.(publicURL.href);
      return res.data;
    } else {
      throw new Error('');
    }
  } else {
    console.log('???');
  }
}

export async function updateImage(galleryId, files, params) {
  if (files?.length) {
    const file = files[0];
    if (!file.preview) {
      return;
    }
    const formData = new FormData();

    const fieldModifiersObject = {
      avatar: file.name,
      ...params,
      // objectType: objectType
    };

    if (!fieldModifiersObject.avatar) {
      delete fieldModifiersObject.avatar;
    }
    // console.log('fieldModifiersObject', fieldModifiersObject);
    // if (!fieldModifiersObject.avatar) {
    //   // delete fieldModifiersObject.avatar;
    //   const gData = await getGallery(galleryId);
    //   console.log('gData', gData);
    //   // fieldModifiersObject.avatar = logoData?.logoName || '-';
    // }

    formData.append('fieldModifiers', JSON.stringify(fieldModifiersObject));

    let demo = await fetch(file.preview).then((r) => r.blob());

    formData.append('file', demo);

    const res = await updateGalleryImage(galleryId, formData);

    if (res.status === 200) {
      // const publicURL = new URL(res.data.publicURL);
      // publicURL.searchParams.set('_id', res.data.logoId);
      // onChange?.(publicURL.href);
      return res.data;
    } else {
      throw new Error('');
    }
  }
}

export async function getGalleryDetailById(setGalleryImages, id) {
  const resImg = await getGalleryImage(id);
  let base64ImageString =
    resImg?.data && Buffer.from(resImg.data, 'binary').toString('base64');
  if (resImg?.status === 200) {
    setGalleryImages((prevState) => ({
      ...prevState,
      [id]: 'data:image/jpeg;base64,' + base64ImageString,
    }));
  } else {
    setGalleryImages((prevState) => ({
      ...prevState,
      [id]: defaultGallery,
    }));
  }
}

export function getPublicUrl(name) {
  return `${BASE_STORAGE_URL}/${name}`;
}

export function getGalleryIdFromUrl(url) {
  try {
    const urlObj = new URL(url);
    const name = urlObj.searchParams.get('galleryId');
    return name || '';
  } catch (error) {
    return '';
  }
}
